import {
    useCallback,
    useState,
    useMemo,
    type FC,
    useRef,
    useId
} from "react";
import type {
    View
} from "react-native";
import type IContextMenuProps from "./type";
import ContextMenuTrigger from "./components/trigger";
import {
    usePointerType
} from "../../helpers/pointer";
import {
    useDropdownMenuRootState
} from "../dropdownMenu/hook";
import type {
    DropdownMenuContextType,
    DropdownMenuPointerType
} from "../dropdownMenu/type";
import {
    DropdownMenuContext
} from "../dropdownMenu/context";
import DropdownMenu from "../dropdownMenu";

const ContextMenu: FC<IContextMenuProps> = ({
    isDisabled = false,
    customLocalize,
    onOpenChange,
    customTheme,
    children,
    title
}) => {
    const pointerType = usePointerType();

    const triggerId = useId();

    const contentId = useId();

    const anchorRef = useRef<View | null>(null);

    const pointerAnchorRef = useRef<View | null>(null);

    const [
        pointer,
        setPointer
    ] = useState<DropdownMenuPointerType | null>(null);

    const {
        handleOpenChange,
        handleTabKey,
        handleClose,
        openMode,
        isOpen
    } = useDropdownMenuRootState({
        isDefaultOpen: false,
        onOpenChange,
        anchorRef
    });

    const handlePointerChange = useCallback((nextPointer: DropdownMenuPointerType | null) => {
        setPointer(nextPointer);
    }, []);

    const handleTriggerWidthChange = useCallback(() => {}, []);

    const value = useMemo<DropdownMenuContextType>(() => ({
        isSheet: pointerType === "coarse",
        handleTriggerWidthChange,
        handlePointerChange,
        handleOpenChange,
        pointerAnchorRef,
        kind: "context",
        triggerWidth: 0,
        align: "start",
        customLocalize,
        side: "bottom",
        handleTabKey,
        customTheme,
        handleClose,
        isDisabled,
        anchorRef,
        contentId,
        triggerId,
        openMode,
        pointer,
        isOpen,
        title
    }), [
        handleTriggerWidthChange,
        handlePointerChange,
        handleOpenChange,
        customLocalize,
        handleTabKey,
        customTheme,
        handleClose,
        pointerType,
        isDisabled,
        contentId,
        triggerId,
        openMode,
        isOpen,
        pointer,
        title
    ]);

    return <DropdownMenuContext.Provider
        value={value}
    >
        {children}
    </DropdownMenuContext.Provider>;
};
export default Object.assign(ContextMenu, {
    CheckboxItem: DropdownMenu.CheckboxItem,
    RadioGroup: DropdownMenu.RadioGroup,
    SubContent: DropdownMenu.SubContent,
    SubTrigger: DropdownMenu.SubTrigger,
    RadioItem: DropdownMenu.RadioItem,
    Separator: DropdownMenu.Separator,
    Shortcut: DropdownMenu.Shortcut,
    Content: DropdownMenu.Content,
    Status: DropdownMenu.Status,
    Trigger: ContextMenuTrigger,
    Empty: DropdownMenu.Empty,
    Group: DropdownMenu.Group,
    Label: DropdownMenu.Label,
    Item: DropdownMenu.Item,
    Sub: DropdownMenu.Sub
});
